/**
 * Checks if an object is fully empty
 * @param {Object} obj The object to check
 * @returns {boolean}
 */
export const objNotEmpty = (obj) => typeof obj === 'object' && Object.keys(obj).length !== 0

/**
 * Checks whether this is an object
 * and if the 'imageType' is a svg
 * @param {Object} image The image object
 * @returns {boolean}
 */
export const isSvgImage = (image) => image?.imageType === 'svg'

/**
 * Sets up the text label for the Trial
 *
 * @param {Boolean} isSubTrial
 * @param {String} umbrellaProtocol
 * @param {Object} subStudiesList
 * @param {String} label
 * @returns {string}
 */
export const formatProtocolText = (
    isSubTrial,
    umbrellaProtocol,
    subStudiesList,
    label
) => {
    if (isSubTrial && umbrellaProtocol) {
        return `: ${umbrellaProtocol}`;
    } else if (subStudiesList && objNotEmpty(subStudiesList)) {
        return `${label}: ${Object.values(subStudiesList).join(', ')}`;
    }
    return '';
}

/**
 * Adds the correct Language Code to the URL
 *
 * @param {String} permalink The URL permalink
 * @returns {string|*}
 */
export const appendLangToLinks = (permalink) => {
    const searchParams = new URLSearchParams(new URL (permalink).search);
    const {langCode} = GLOBAL

    if (langCode !== 'en' && !searchParams.has('lang')) {
        return `${permalink}?lang=${langCode}`
    }

    return permalink
}

/**
 * Generates an HTMLElement for the Google Map Advanced Markers
 *
 * @param {String} svgString The SVG string passed through
 * @returns {HTMLElement}
 */
export const generateSvgFromString = (svgString) => {
    const parser = new DOMParser();
    return parser.parseFromString(
        svgString,
        'image/svg+xml'
    ).documentElement;
}

/**
 * Reusable method to scroll to an element in the parent container
 * with a little bit of padding
 *
 * @param {HTMLElement} element The element to scroll to
 * @param {HTMLElement} parent The parent container
 * @param {Number} padding The amount to deduct from the scroll
 */
export const scrollToElement = (element, parent, padding = 0) => {
    const elementReact = element.getBoundingClientRect()
    const parentReact = parent.getBoundingClientRect()
    const offsetTop = (elementReact.top + parent.scrollTop) - parentReact.top - padding

    parent.scrollTo({
        top: offsetTop,
        behavior: 'smooth'
    })
}
